import React from 'react';
import './Loader.scss';


export default class Loader extends React.Component{
    constructor (props) {
        super(props);
        this.state = {
            show: true,
            height: '25px'
        };

        const pulse = () => {
            this.fadeInOut = setTimeout(() => {
                this.setState({ show: !this.state.show });
                pulse();
            }, 1000);
        };

        pulse();
    }

    componentWillUnmount () {
        this.setState({ height: 0 });
        clearTimeout(this.fadeInOut);
    }

    render () {

        return(
            <div style={ { height: this.state.height} } className={ this.state.show ? 'noon-loader' : 'noon-loader transparent' }>
                <div className="noon-loader__imagecontainer">
                    <img src='https://s3-us-west-2.amazonaws.com/com-noonhome-web/Pro/Loader/noon-logo.png' alt="" />
                </div>
            </div>
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/Loader/index.js